import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { isFeatureHomeButtonActive } from "../../util/featureAccess/featureAccessUtils.js";
import DashboardEmployeeBidsCard from "./DashboardEmployeeBidsCard.jsx";
import DashboardEmployeePermanentBid from "./DashboardEmployeePermanentBid.jsx";
import DashboardEmployeeQuickLinksCard from "./DashboardEmployeeQuickLinksCard.jsx";
import DashboardEmployeeSeniorityListCard from "./DashboardEmployeeSeniorityListCard.jsx";

const EmployeeDashboard = ({ ...props }) => {
  const renderPageContent = () => {
    const renderMobileView = () => {
      return (
        <Grid container justifyContent="center">
          <Box p={1} sx={{ width: "100%" }}>
            <Grid container spacing={1}>
              {isFeatureHomeButtonActive(props.userFeatures, "myBids") && (
                <Grid item xs={12}>
                  <DashboardEmployeeBidsCard isDesktopView={props.isDesktopView} />
                </Grid>
              )}
              <Grid item xs={12}>
                <DashboardEmployeeQuickLinksCard
                  userFeatures={props.userFeatures}
                  isDesktopView={props.isDesktopView}
                />
              </Grid>
              {isFeatureHomeButtonActive(props.userFeatures, "mySeniorityList") && (
                <Grid item xs={12}>
                  <DashboardEmployeeSeniorityListCard />
                </Grid>
              )}

              {isFeatureHomeButtonActive(props.userFeatures, "myPermanentBid") && (
                <Grid item xs={12}>
                  <DashboardEmployeePermanentBid />
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      );
    };

    const renderDesktopView = () => {
      return (
        <Grid
          container
          sx={{
            justifyContent: "center",
            paddingLeft: "1rem",
            paddingRight: "1rem",
          }}
        >
          <Grid item xs={4} sx={{ display: "flex", justifyContent: "end" }} pr={1}>
            <Stack direction="column" spacing={1} sx={{ width: "100%" }} alignItems="flex-end">
              <DashboardEmployeeQuickLinksCard userFeatures={props.userFeatures} isDesktopView={props.isDesktopView} />
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
              {isFeatureHomeButtonActive(props.userFeatures, "myBids") && (
                <DashboardEmployeeBidsCard isDesktopView={props.isDesktopView} />
              )}
              {isFeatureHomeButtonActive(props.userFeatures, "myPermanentBid") && (
                <Grid item xs={12}>
                  <DashboardEmployeePermanentBid />
                </Grid>
              )}
              {isFeatureHomeButtonActive(props.userFeatures, "mySeniorityList") && (
                <DashboardEmployeeSeniorityListCard isDesktopView={props.isDesktopView} />
              )}
            </Stack>
          </Grid>
        </Grid>
      );
    };

    return props.isDesktopView ? renderDesktopView() : renderMobileView();
  };
  return <div className="App-contents enable-scroll">{renderPageContent()}</div>;
};

EmployeeDashboard.propTypes = {
  isDesktopView: PropTypes.bool.isRequired,
  userFeatures: PropTypes.array.isRequired,
};

export default EmployeeDashboard;
